import { getApiByWithoutId } from "../../Shared/Services/RestService";
import { RecruiterDashboardResponse } from "../Types/RecruiterDashboardType";

export const getRecruiterDashboard = () => {
  return getApiByWithoutId<RecruiterDashboardResponse>("/recruiter/dashboard");
};